import { FunctionComponent, useCallback } from "react";
import { Text } from "@ui-kit/Text/Text";
import { IconButton } from "@ui-kit/IconButton/IconButton";
import { MapIcon } from "@icons/MapIcon";
import { useTranslation } from "react-i18next";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";
import { setMenuItemAction } from "@store/menuItem/menuItemReducer";
import { useAppDispatch, useAppSelector } from "@store/store";
import { selectLastMenuItem } from "@store/menuItem/menuItemReducer";
import { AiButton } from "@modules/components/buttons/AiButton/AiButton";
import { selectIsTripBuilderEnabled } from "@store/client/clientReducer";
import { useNavigate } from "@hooks/useNavigate/useNavigate";

import "./EmptyPlan.css";
import { EntityBackButton } from "@modules/components/buttons/EntityBackButton/EntityBackButton";
import { useWindowSize } from "@hooks/useWindowSize/useWindowSize";

const EmptyPlan: FunctionComponent = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const lastMenuItem = useAppSelector(selectLastMenuItem);
  const isTripBuilderEnabled = useAppSelector(selectIsTripBuilderEnabled);
  const navigate = useNavigate();
  const { isMobile } = useWindowSize();

  const handleReturnToExplorePress = useCallback(() => {
    navigate(lastMenuItem!.analyticsPath);
    dispatch(setMenuItemAction(lastMenuItem));
  }, [dispatch, lastMenuItem, navigate]);

  return (
    <div className="empty-plan-component">
      {isMobile && (
        <div className="plan-action-bar-container">
          <div className="cover-actions-top-left">
            <EntityBackButton />
          </div>
        </div>
      )}

      <div className="plan-component-content empty-plan-content">
        <div className="plan-component-text-container">
          <Text variant="fontHeadingXsmall">
            {t("screens.plan.noPlanItems.title")}
          </Text>
          <Text variant="fontBodyMedium">
            {t("screens.plan.noPlanItems.description")}
          </Text>
        </div>
        <IconButton
          onPress={handleReturnToExplorePress}
          label={t("screens.plan.noPlanItems.exploreLabel")}
          icon={<MapIcon size={18} color={colors.primary60} />}
        />
      </div>
      {isTripBuilderEnabled && (
        <div className="plan-component-content">
          <div className="plan-component-text-container">
            <Text variant="fontHeadingXsmall">
              {t("ai.tripBuilder.launch.title")}
            </Text>
            <Text variant="fontBodyMedium">
              {t("ai.tripBuilder.launch.description")}
            </Text>
          </div>
          <AiButton label={t("ai.tripBuilder.launch.helpMePlan")} flex={true} />
        </div>
      )}
    </div>
  );
};

export { EmptyPlan };
